import {
  GROUPS_LIST_SORT_FIELD,
  GROUP_TYPE,
  type MinistryGroupFormValues,
  type MinistryGroupsListRequestFiltersData,
  SORT_DIRECTION,
} from '@/types';

export const MIN_MINISTRY_GROUP_KEYWORD_LENGTH = 3;
export const MAX_MINISTRY_GROUP_KEYWORD_LENGTH = 10;
export const MAX_MINISTRY_GROUP_SHORT_NAME_LENGTH = 15;
export const MINISTRY_GROUP_KEYWORD_PATTERN = /^[a-z0-9]+$/;
export const MINISTRY_GROUP_MAX_VISIBLE_LEVELS = 3;
export const MINISTRY_GROUP_PARENT_CANDIDATES_LIMIT = 100;
export const MINISTRY_CHURCH_DIRECTORY_LIMIT = 100;
export const MINISTRY_GROUP_ADMIN_SEARCH_LIMIT = 20;

export const emptyMinistryGroupsListRequestFilters: MinistryGroupsListRequestFiltersData = {
  term: '',
  types: [],
  sortBy: GROUPS_LIST_SORT_FIELD.CREATED_DATE,
  sortOrder: SORT_DIRECTION.DESC,
};

export const emptyMinistryGroupFormValues: MinistryGroupFormValues = {
  name: '',
  shortName: '',
  description: '',
  keyword: '',
  type: GROUP_TYPE.PUBLIC,
  isActive: true,
  parentId: null,
  calendarIds: [],
  trainingRequirementIds: [],
  locations: [],
  adminIds: [],
};
